<template>
  <div class="container box_component">
    <h1 class="display-4 flex-wrap d-flex align-items-end gap-2">
      <span>{{ $t('notification.panel.title') }}</span>
      <small class="h5 mb-1 text-muted">{{ $t('notification.panel.subtitle') }}</small>
    </h1>
    <p class="lead">{{ $t('notification.panel.lead') }}</p>

    <!-- <div class="notif-controls d-flex flex-wrap gap-2 align-items-center mb-3">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <button class="btn btn-sm btn-outline-secondary" @click="toggleSelectAllPage">
          {{ allSelected ? $t('notification.controls.clear') : $t('notification.controls.select_all') }}
        </button>
        <span class="text-muted small">
          {{ $t('notification.controls.selected_count', { count: selectedCount }) }}
        </span>
      </div>
      <div class="ms-auto d-flex align-items-center gap-2 flex-wrap">
        <button class="btn btn-sm btn-outline-primary" :disabled="!selectedCount" @click="markSelectedRead">
          <i class="fa-solid fa-envelope-open-text"></i>
          <span>{{ $t('notification.controls.mark_read') }}</span>
        </button>
        <button class="btn btn-sm btn-outline-danger" :disabled="!selectedCount" @click="deleteSelected">
          <i class="fa-solid fa-trash"></i>
          <span>{{ $t('notification.controls.delete') }}</span>
        </button>
      </div>
    </div> -->

    <div class="notif-box">
      <h2 class="notif-title">{{ $t('notification.panel.latest') }}</h2>
      <ul v-if="paginatedNotifications.length" class="notif-list">
        <li
            v-for="item in paginatedNotifications"
            :key="item.id"
            :id="`notif-${item.id}`"
            @click="toggle(item.id)"
            class="notif-item"
            :class="{ unread: !isRead(item.id) }"
        >
            <!-- <input
              type="checkbox"
              class="form-check-input mt-1"
              :checked="selectedIds.has(Number(item.id))"
              @change.stop="toggleSelect(item.id)"
            /> -->
          <i :class="item.iconClass"></i>
          <div class="notif-text flex-grow-1">
            <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
              <div>
                <strong :class="{ 'fw-semibold': !isRead(item.id) }">{{ item.title }}</strong>
                <small class="text-muted d-block">{{ item.metaText }}</small>
              </div>
              <div class="d-flex align-items-center gap-2">
                <!-- <button class="btn btn-ghost btn-sm" :disabled="isRead(item.id)" @click.stop="markSingleRead(item.id)">
                  <i class="fa-solid fa-envelope-open"></i>
                </button> -->
                <button class="btn btn-ghost btn-sm text-danger" @click.stop="deleteSingle(item.id)">
                  <i class="fa-solid fa-trash"></i>
                </button>
                <i :class="isOpen(item.id) ? 'fa-solid fa-chevron-up text-secondary' : 'fa-solid fa-chevron-down text-secondary'"></i>
              </div>
            </div>
            <transition name="fade">
              <div v-if="isOpen(item.id)" class="notif-detail mt-2">
                <p class="mb-2">{{ item.message }}</p>
                <div v-if="item.actions && item.actions.length" class="d-flex flex-wrap gap-2">
                  <button
                      v-for="action in item.actions"
                      :key="action.label"
                      class="btn btn-sm d-flex align-items-center gap-1"
                      :class="buttonVariantClass(action.variant)"
                      @click.stop="onAction(item, action)"
                  >
                    <i v-if="action.iconClass" :class="action.iconClass"></i>
                    <span>{{ action.label }}</span>
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </li>
      </ul>
      <div v-else class="text-muted small py-2">{{ $t('notification.panel.empty') }}</div>

      <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted small">
          {{ $t('notification.panel.page') }} {{ currentPage }} {{ $t('notification.panel.of') }} {{ totalPages }} · {{ $t('notification.panel.showing', { from: displayFrom, to: displayTo, total: totalCount }) }}
        </div>
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-sm btn-outline-secondary" :disabled="currentPage === 1" @click="goPrev">Anterior</button>
          <button class="btn btn-sm btn-outline-secondary" :disabled="currentPage === totalPages" @click="goNext">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- Modal de confirmación -->
    <div v-if="showConfirmModal" class="modal-backdrop">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ confirmActionType === 'accept' ? $t('notification.confirm.accept') : $t('notification.confirm.decline') }}
            </h5>
          </div>
          <div class="modal-body">
            <p>
              {{ confirmMessage() }}
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showConfirmModal = false">{{ $t('notification.confirm.cancel') }}</button>
            <button class="btn btn-primary" @click="handleConfirmedAction">{{ $t('notification.confirm.confirm') }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal confirmación eliminación -->
    <div v-if="showDeleteModal" class="modal-backdrop">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('notification.confirm.delete_title') }}</h5>
          </div>
          <div class="modal-body">
            <p>{{ confirmDeleteMessage() }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showDeleteModal = false">{{ $t('notification.confirm.cancel') }}</button>
            <button class="btn btn-primary" @click="handleDeleteConfirm">{{ $t('notification.confirm.confirm') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import echoService from '@/services/echoService';
import { fetchStatusUpdate } from '@/helpers/fetchUtils';
import { fetchNotifications, markRead as apiMarkRead, markBulk as apiMarkBulk, deleteNotification as apiDelete, deleteBulk as apiDeleteBulk } from '@/services/notificationService';

export default {
  name: 'NotificationsView',
  data() {
    return {
      notifications: [],
      openItems: new Set(),
      readIds: [],
      channel: null,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      displayFrom: 0,
      displayTo: 0,
      loading: false,
      showConfirmModal: false,
      confirmActionType: null,
      confirmRole: null,
      confirmActor: 'invitee',
      pendingAction: null,
      disabledActions: new Map(),
      selectedIds: new Set(),
      showDeleteModal: false,
      deleteTargetIds: [],
    };
  },
  computed: {
    ...mapState('user', ['token', 'user']),
    paginatedNotifications() {
      return this.notifications;
    },
    selectedCount() {
      return this.selectedIds.size;
    },
    allSelected() {
      if (!this.notifications.length) return false;
      return this.notifications.every(n => this.selectedIds.has(Number(n.id)));
    }
  },
  methods: {
    fetchStatusUpdate,
    subscribeToChannel() {
      const userId = this.user?.id;
      if (!userId) return;
      const echo = echoService?.getInstance ? echoService.getInstance() : echoService;
      if (!echo?.private) return;

      const channelName = `notifications.${userId}`;
      this.channel = echo.private(channelName);

      this.channel.listen('NotificationUpdated', (payload) => {
        console.log('[NotificationsView] NotificationUpdated via Echo', payload);
        this.handleRealtimeUpdate(payload);
      });

      this.channel.listen('NotificationCreated', (payload) => {
        console.log('[NotificationsView] NotificationCreated via Echo', payload);
        const notification = this.extractNotificationFromPayload(payload);
        if (notification) {
          this.handleNotificationCreated({ detail: notification });
        }
      });
    },

    extractNotificationFromPayload(payload) {
      if (!payload) return null;
      if (payload.data && typeof payload.data === 'string') {
        try { return JSON.parse(payload.data); } catch (e) { return null; }
      }
      if (payload.notification) return payload.notification;
      if (payload.data && typeof payload.data === 'object') return payload.data;
      if (typeof payload === 'string') {
        try { return JSON.parse(payload); } catch (e) { return null; }
      }
      return payload;
    },
    isOpen(id) {
      return this.openItems.has(Number(id));
    },
    toggle(id) {
      const numericId = Number(id);
      // Solo una notificación abierta a la vez
      if (this.openItems.has(numericId)) {
        this.openItems.clear();
      } else {
        this.openItems.clear();
        this.openItems.add(numericId);
        this.markRead(numericId);
      }
      this.openItems = new Set(this.openItems);
    },
    isRead(id) {
      const numericId = Number(id);
      const found = this.notifications.find(n => n.id === numericId);
      if (found) return found.status === 'read';
      return this.readIds.includes(numericId);
    },
    async markRead(id) {
      const numericId = Number(id);
      if (!numericId || this.isRead(numericId)) return;
      try {
        await apiMarkRead(numericId);
        this.notifications = this.notifications.map(n =>
            n.id === numericId ? { ...n, status: 'read', read_at: new Date().toISOString() } : n
        );
        this.readIds = [...new Set([...this.readIds, numericId])];
        // Notifica al resto de la app (campana) que se leyó
        window.dispatchEvent(new CustomEvent('notification:read', { detail: { id: numericId } }));
      } catch (e) {
        console.error('Error marcando notificación', e);
      }
    },
    async markSelectedRead() {
      const ids = Array.from(this.selectedIds).map(Number).filter(Boolean);
      if (!ids.length) return;
      try {
        await apiMarkBulk(ids);
        const now = new Date().toISOString();
        this.notifications = this.notifications.map(n =>
            ids.includes(Number(n.id)) ? { ...n, status: 'read', read_at: n.read_at || now } : n
        );
        this.readIds = [...new Set([...this.readIds, ...ids])];
        window.dispatchEvent(new CustomEvent('notification:read', { detail: { ids } }));
      } catch (e) {
        console.error('Error marcando notificaciones por lote', e);
      }
    },
    async deleteSelected() {
      const ids = Array.from(this.selectedIds).map(Number).filter(Boolean);
      if (!ids.length) return;
      try {
        await apiDeleteBulk(ids);
        this.selectedIds = new Set();
        await this.fetchPage(this.currentPage);
      } catch (e) {
        console.error('Error eliminando notificaciones por lote', e);
      }
    },
    async deleteSingle(id) {
      const numericId = Number(id);
      if (!numericId) return;
      this.deleteTargetIds = [numericId];
      this.showDeleteModal = true;
    },
    async markSingleRead(id) {
      const numericId = Number(id);
      if (!numericId || this.isRead(numericId)) return;
      await this.markRead(numericId);
    },
    toggleSelect(id) {
      const numericId = Number(id);
      if (!numericId) return;
      if (this.selectedIds.has(numericId)) {
        this.selectedIds.delete(numericId);
      } else {
        this.selectedIds.add(numericId);
      }
      this.selectedIds = new Set(this.selectedIds);
    },
    toggleSelectAllPage() {
      if (this.allSelected) {
        this.notifications.forEach(n => this.selectedIds.delete(Number(n.id)));
      } else {
        this.notifications.forEach(n => this.selectedIds.add(Number(n.id)));
      }
      this.selectedIds = new Set(this.selectedIds);
    },
    clearSelection() {
      this.selectedIds = new Set();
    },
    async fetchPage(page = 1) {
      this.loading = true;
      try {
        const res = await fetchNotifications({ page, perPage: this.pageSize });
        const list = res?.data || res || [];
        const meta = res?.meta || {};
        this.notifications = list.map(this.normalizeItem);
        this.pageSize = meta.per_page ?? this.pageSize;
        this.totalCount = meta.total ?? list.length;
        this.totalPages = meta.last_page ?? Math.max(1, Math.ceil(this.totalCount / this.pageSize));
        this.currentPage = meta.current_page ?? page;
        const from = meta.from ?? (list.length ? (this.currentPage - 1) * this.pageSize + 1 : 0);
        const to = meta.to ?? (from ? from - 1 + list.length : 0);
        this.displayFrom = from;
        this.displayTo = to;
        this.clearSelection();
      } catch (e) {
        console.error('Error cargando notificaciones', e);
      } finally {
        this.loading = false;
      }
    },
    async ensureOpen(id) {
      const numericId = Number(id);
      if (!numericId) return;

      // If not in current page, iterate pages until found or exhausted
      let idx = this.notifications.findIndex(n => n.id === numericId);
      if (idx === -1) {
        const maxPages = this.totalPages || 1;
        for (let page = 1; page <= maxPages; page += 1) {
          await this.fetchPage(page);
          idx = this.notifications.findIndex(n => n.id === numericId);
          if (idx !== -1) break;
        }
      }

      if (idx === -1) return;

      await this.markRead(numericId);
      this.openItems.add(numericId);
      this.openItems = new Set(this.openItems);
      this.$nextTick(() => {
        const el = document.getElementById(`notif-${numericId}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    openFromQuery() {
      const id = this.$route?.query?.openId;
      if (id) {
        this.ensureOpen(id);
      }
    },
    async onAction(item, action) {
      if (!action) return;
      const isStatus = action.type === 'status' || action.status !== undefined || action.status_id !== undefined || action.new_status !== undefined;
      if (isStatus) {
        await this.onInviteAction(action, item);
        return;
      }
      const nav = this.mapActionToRoute(action);
      if (nav) {
        await this.prepareNavigationContext(nav);
        this.$router.push(nav);
      }
    },
    async prepareNavigationContext(nav) {
      const isCompetitionView = nav?.path === '/competitionView';
      const competitionId = Number(nav?.query?.id ?? nav?.params?.id ?? 0);

      if (!isCompetitionView || !Number.isFinite(competitionId) || competitionId <= 0) {
        return;
      }

      await this.$store.dispatch('competition/clearAppNavigationZone', 'competition');
      await this.$store.dispatch('competition/clearCompetition');
      await this.$store.dispatch('competition/clearCompetitionIdToView');
      await this.$store.dispatch('competition_users/clearCompetitionUsers');
      await this.$store.dispatch('competition_users/clearAtheletesListArray');
      await this.$store.dispatch('competition_users/clearJudgesListArray');
      await this.$store.dispatch('round/clearRound');
      await this.$store.dispatch('round/clearPodium');
      await this.$store.dispatch('round/clearCompetitionRoundIdToView');
      await this.$store.dispatch('round/clearCompetitionRoundIdToCreate');
      await this.$store.dispatch('round/clearCompetitionRoundIdToEdit');
      await this.$store.dispatch('competition/setCompetitionIdToView', competitionId);
    },
    async onInviteAction(action, item) {
      this.pendingAction = { action, item };
      const kind = this.resolveActionKind(action);
      this.confirmActionType = kind === 'accept' ? 'accept' : 'decline';
      this.confirmActor = this.isOrganizerAction(action, item) ? 'organizer' : 'invitee';
      const payload = item.payload || item.meta || {};
      this.confirmRole = this.resolveParticipantRole(action, payload, item);
      this.showConfirmModal = true;
    },
    confirmMessage() {
      const isOrganizer = this.confirmActor === 'organizer';
      const isJudge = this.confirmRole === 'judge';
      const isCoOrganizer = this.confirmRole === 'organizer';
      const acceptKey = isOrganizer
        ? (isJudge
          ? 'notification.confirm.approve_message_judge'
          : isCoOrganizer
            ? 'notification.confirm.approve_message_organizer'
            : 'notification.confirm.approve_message_athlete')
        : (isJudge
          ? 'notification.confirm.accept_message_judge'
          : isCoOrganizer
            ? 'notification.confirm.accept_message_organizer'
            : 'notification.confirm.accept_message_athlete');
      const declineKey = isOrganizer
        ? (isJudge
          ? 'notification.confirm.reject_message_judge'
          : isCoOrganizer
            ? 'notification.confirm.reject_message_organizer'
            : 'notification.confirm.reject_message_athlete')
        : (isJudge
          ? 'notification.confirm.decline_message_judge'
          : isCoOrganizer
            ? 'notification.confirm.decline_message_organizer'
            : 'notification.confirm.decline_message_athlete');
      const key = this.confirmActionType === 'accept' ? acceptKey : declineKey;
      return this.$t ? this.$t(key) : key;
    },
    isOrganizerAction(action = {}, item = {}) {
      const type = (action.type || '').toString().toLowerCase();
      const status = Number(action.status ?? action.status_id ?? action.new_status);
      const key = (item.key || item.type || '').toString().toLowerCase();
      return type === 'approval'
          || status === 4
          || /invite_accepted|invite_declined/.test(key);
    },
    normalizeParticipantRole(value) {
      const normalized = (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[_\s-]+/g, ' ');

      if (!normalized) return null;
      if (normalized.includes('judge') || normalized.includes('juez') || normalized.includes('richter') || normalized.includes('juge') || normalized.includes('giudic')) {
        return 'judge';
      }
      if (normalized.includes('organizer') || normalized.includes('organiser') || normalized.includes('organizador') || normalized.includes('organizzatore') || normalized.includes('veranstalter') || normalized.includes('共同オーガナイザー')) {
        return 'organizer';
      }
      if (normalized.includes('athlete') || normalized.includes('atleta') || normalized.includes('athl')) {
        return 'athlete';
      }
      return null;
    },
    resolveParticipantRole(action = {}, payload = {}, item = {}) {
      const candidates = [
        action.role,
        payload.role,
        action.entity,
        payload.entity,
        action.resource,
        action.target,
        action.subject,
        item.key,
        item.type,
        item.title,
        item.message,
      ];

      for (const candidate of candidates) {
        const normalized = this.normalizeParticipantRole(candidate);
        if (normalized) return normalized;
      }

      return 'athlete';
    },
    async handleConfirmedAction() {
      this.showConfirmModal = false;
      if (!this.pendingAction) return;
      const { action, item } = this.pendingAction;
      try {
        await this.handleStatusAction(item, action);
        // Marca como leída y deshabilita localmente mientras llega el update real
        this.markRead(item.id);
        const idx = this.notifications.findIndex(n => n.id === item.id);
        if (idx !== -1) {
          const updated = { ...this.notifications[idx], processed_at: new Date().toISOString(), action: null };
          this.notifications.splice(idx, 1, this.normalizeItem(updated));
        }
        // Refresca la página actual para traer el action actualizado del backend
        await this.fetchPage(this.currentPage);
        const payload = item?.payload || item?.meta || {};
        const competitionId = Number(
          action?.competition_id
          ?? action?.params?.competition_id
          ?? action?.params?.competitionId
          ?? payload?.competition_id
          ?? payload?.competitionId
          ?? payload?.competition?.id
          ?? 0
        );
        window.dispatchEvent(new CustomEvent('competition:updated', {
          detail: competitionId ? { competitionId } : {},
        }));
      } catch (e) {
        console.error('❌ Error al cambiar estado:', e);
      }
      this.pendingAction = null;
      this.confirmRole = null;
      this.confirmActor = 'invitee';
    },
    isActionDisabled(itemId) {
      return this.disabledActions.has(itemId);
    },
    buttonVariantClass(variant) {
      const map = {
        primary: 'btn-primary',
        secondary: 'btn-outline-secondary',
        success: 'btn-success',
        danger: 'btn-outline-danger',
        warning: 'btn-warning',
        info: 'btn-info'
      };
      return map[variant] || 'btn-outline-secondary';
    },
    async handleStatusAction(item, action) {
      if (this.disabledActions.get(item.id)) return;
      this.disabledActions.set(item.id, true);
      const payload = item.payload || item.meta || {};
      const kind = this.resolveActionKind(action);
      console.log('Manejando acción de estado', action);
      let entity = action.entity
          || action.resource
          || action.target
          || action.subject;
console.log('Valor de entity: ', entity);
                  
      // Corrige: si hay role, conviértelo igual que en CompetitionView
      const role = this.resolveParticipantRole(action, payload, item);
      if (!entity && role) {
        if (role === 'athlete' || role === 'athletes') entity = 'athletes';
        else if (role === 'judge' || role === 'judges') entity = 'judges';
        else if (role === 'organizer' || role === 'organizers') entity = 'organizers';
        else if (typeof role === 'string') entity = role.endsWith('s') ? role : (role + 's');
        else entity = role;
      }

        const targetId = Number(
          action.id
          ?? action.resource_id
          ?? action.competition_user_id
          ?? action.target_id
          ?? action.subject_id
          ?? action.params?.competition_user_id
          ?? action.params?.id
          ?? payload.competition_user_id
          ?? payload.id
        );

      const statusId = Number(
          action.status
          ?? action.status_id
          ?? action.new_status
          ?? payload.status_id
          ?? (kind === 'accept' ? 3 : kind === 'decline' ? 5 : undefined)
      );

      // Si no tenemos todo para actualizar estado, no navegamos: se requiere competition_user_id
      if (!entity || !targetId || !statusId) {
        console.warn('Acción de notificación sin datos suficientes para actualizar estado', { entity, targetId, statusId, action, payload });
        return;
      }

      try {
        this.loading = true;
        const res = await this.fetchStatusUpdate(this.token, entity, targetId, statusId, action.source || null);
        const ok = res?.data?.success ?? res?.success;
        if (ok) {
          this.notifications = this.notifications.map(n =>
              n.id === item.id ? { ...n, status: 'read', read_at: n.read_at || new Date().toISOString() } : n
          );
          this.readIds = [...new Set([...this.readIds, Number(item.id)])];
          window.dispatchEvent(new CustomEvent('notification:read', { detail: { id: item.id } }));
        }
      } catch (e) {
        console.error('Error aplicando acción de notificación', e);
      } finally {
        this.loading = false;
        this.disabledActions.delete(item.id);
      }
    },
    goPrev() {
      if (this.currentPage > 1) {
        this.fetchPage(this.currentPage - 1);
      }
    },
    goNext() {
      if (this.currentPage < this.totalPages) {
        this.fetchPage(this.currentPage + 1);
      }
    },
    normalizeItem(n) {
      if (!n) return n;
      const payload = n.payload || n.meta || {};
      const metaText = this.composeMetaText(payload);
      const key = n.key || n.type || '';
      const fallbackTitle = n.title || key || 'Notificación';
      const fallbackMessage = n.message || n.detail || key || '';
      const actions = this.buildActions(n);
      const processed = !!n.processed_at || !n.action; // Nueva lógica: procesada si tiene processed_at o no tiene action
      return {
        ...n,
        iconClass: this.normalizeIcon(n.icon),
        metaText,
        title: this.getTranslation(key, payload, 'title', fallbackTitle),
        message: this.getTranslation(key, payload, 'message', fallbackMessage),
        payload,
        actions,
        processed
      };
    },
    buildActions(n) {
      const action = n.action;
      if (!action) return [];
      const contextPayload = n.payload || n.meta || {};
      const baseAction = { ...action, contextPayload };

      const rawOptions = Array.isArray(action.options)
          ? action.options
          : (action.options && typeof action.options === 'object')
              ? Object.values(action.options)
              : null;

      if (rawOptions && rawOptions.length) {
        return rawOptions
            .map(opt => this.normalizeActionOption(baseAction, opt))
            .filter(Boolean);
      }

      return [this.normalizeActionOption(baseAction, action)].filter(Boolean);
    },
    handleRealtimeUpdate(eventData) {
      console.log('[NotificationsView] notification:updated recibido', eventData);
      let updated = eventData;
      if (updated?.data && typeof updated.data === 'string') {
        try {
          updated = JSON.parse(updated.data);
        } catch (e) {
          console.error('[NotificationsView] Error parseando notification:updated', e);
          return;
        }
      } else if (typeof updated === 'string') {
        try {
          updated = JSON.parse(updated);
        } catch (e) {
          console.error('[NotificationsView] Error parseando notification:updated', e);
          return;
        }
      }
      if (!updated || !updated.id) {
        console.warn('[NotificationsView] notification:updated sin id', updated);
        return;
      }
      const updatedItem = this.normalizeItem(updated);
      const index = this.notifications.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        this.notifications = [
          ...this.notifications.slice(0, index),
          updatedItem,
          ...this.notifications.slice(index + 1)
        ];
        console.log('[NotificationsView] Notificación actualizada en array, id:', updatedItem.id);
      } else {
        console.warn('[NotificationsView] Notificación no encontrada en página, id:', updatedItem.id);
      }
    },
    normalizeActionOption(base, option = {}) {
      const merged = { ...base, ...option };
      const contextPayload = merged.contextPayload || {};
      const kind = this.resolveActionKind(merged);
      const status = merged.status ?? merged.status_id ?? merged.new_status ?? contextPayload.status_id ?? (kind === 'accept' ? 3 : kind === 'decline' ? 5 : undefined);
      const type = merged.type || (status !== undefined ? 'status' : 'navigate');

      return {
        label: merged.label || this.actionLabel(kind),
        variant: merged.variant || this.actionVariant(kind),
        iconClass: merged.iconClass || merged.icon || this.actionIcon(kind),
        type,
        route: merged.route,
        params: merged.params || {},
        path: merged.path || null,
        entity: merged.entity || merged.resource || merged.role || merged.target || merged.subject || contextPayload.entity || contextPayload.role,
        status,
        id: merged.id
            ?? merged.resource_id
            ?? merged.competition_user_id
            ?? merged.target_id
            ?? merged.subject_id
            ?? merged.params?.competition_user_id
            ?? merged.params?.id
            ?? contextPayload.competition_user_id
            ?? contextPayload.id,
        source: merged.source || null
      };
    },
    resolveActionKind(action = {}) {
      const rawType = (action.type || action.name || '').toString().toLowerCase();
      const status = action.status ?? action.status_id ?? action.new_status;
      const payloadStatus = action.contextPayload?.status_id;
      const combinedStatus = status ?? payloadStatus;

      if ([3, 4].includes(Number(combinedStatus))) return 'accept';
      if (Number(combinedStatus) === 5) return 'decline';
      if (['accept', 'approve', 'confirm', 'ok', 'yes'].includes(rawType)) return 'accept';
      if (['decline', 'reject', 'deny', 'cancel', 'no'].includes(rawType)) return 'decline';
      return 'view';
    },
    actionLabel(kind) {
      const map = {
        accept: this.$t ? this.$t('notification.action.accept') : 'Accept',
        decline: this.$t ? this.$t('notification.action.decline') : 'Decline',
        view: this.$t ? this.$t('notification.action.view') : 'View'
      };
      return map[kind] || map.view;
    },
    actionVariant(kind) {
      if (kind === 'accept') return 'success';
      if (kind === 'decline') return 'danger';
      return 'primary';
    },
    actionIcon(kind) {
      if (kind === 'accept') return 'fa-solid fa-thumbs-up';
      if (kind === 'decline') return 'fa-solid fa-user-slash';
      return 'fa-solid fa-arrow-right';
    },
    mapActionToRoute(action) {
      if (action.path) return action.path;
      if (action.route === 'round.view') {
        const roundId = action.params?.roundId || action.params?.id;
        if (roundId) {
          return { path: '/score', query: { roundId } };
        }
      }
      // Custom mapping for competition view
      if (action.route === 'competition.view') {
        const competitionId = action.params?.competitionId || action.params?.id;
        return { path: '/competitionView', query: { id: competitionId, from: 'notification' } };
      }
      if (action.route && this.$router?.hasRoute && this.$router.hasRoute(action.route)) {
        return { name: action.route, params: action.params || {} };
      }
      if (action.route) {
        return { path: action.route, query: action.params || {} };
      }
      return null;
    },
    composeMetaText(meta = {}) {
      const parts = [];
      if (meta.competition) parts.push(meta.competition);
      if (meta.round) parts.push(meta.round);
      if (meta.group) parts.push(meta.group);
      if (meta.role) parts.push(meta.role);
      if (meta.status) parts.push(meta.status);
      if (meta.location) parts.push(meta.location);
      if (meta.document) parts.push(meta.document);
      if (meta.starts_in) parts.push(`Empieza en ${meta.starts_in}`);
      if (meta.window) parts.push(`Ventana ${meta.window}`);
      return parts.join(' · ');
    },
    confirmDeleteMessage() {
      const count = this.deleteTargetIds.length || 1;
      if (count > 1) return this.$t('notification.confirm.delete_message_multi', { count });
      return this.$t('notification.confirm.delete_message_single');
    },
    async handleDeleteConfirm() {
      const ids = (this.deleteTargetIds || []).map(Number).filter(Boolean);
      if (!ids.length) {
        this.showDeleteModal = false;
        return;
      }
      try {
        if (ids.length === 1) {
          await apiDelete(ids[0]);
          this.selectedIds.delete(ids[0]);
        } else {
          await apiDeleteBulk(ids);
          ids.forEach(id => this.selectedIds.delete(id));
        }
        await this.fetchPage(this.currentPage);
      } catch (e) {
        console.error('Error eliminando notificación(es)', e);
      } finally {
        this.showDeleteModal = false;
        this.deleteTargetIds = [];
      }
    },
    handleNotificationCreated(event) {
      const raw = event?.detail;
      if (!raw) return;
      const item = this.normalizeItem(raw);

      // If we're on page 1, prepend and trim to pageSize
      if (this.currentPage === 1) {
        const nextList = [item, ...this.notifications];
        this.notifications = nextList.slice(0, this.pageSize);
        this.displayFrom = this.notifications.length ? 1 : 0;
        this.displayTo = this.notifications.length;
      }

      // Always update counts/pages
      this.totalCount += 1;
      this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    },
    getTranslation(key, payload = {}, variant, fallback = '') {
      if (!key) return fallback;
      const paths = this.buildPaths(key, variant);
      for (const p of paths) {
        if (this.canTranslate(p)) {
          return this.$t ? this.$t(p, payload) : fallback || key;
        }
      }
      return fallback || key;
    },
    buildPaths(key, variant) {
      const cleanKey = key.replace(/^\.+/, '');
      const base = cleanKey.startsWith('notification.') ? cleanKey : `notification.${cleanKey}`;
      const alt = base.replace(/^notification\./, 'notifications.');
      const deep = alt.startsWith('notifications.notification.') ? alt : `notifications.notification.${cleanKey.replace(/^notification\./, '')}`;
      return [`${base}.${variant}`, `${alt}.${variant}`, `${deep}.${variant}`];
    },
    canTranslate(path) {
      if (this.$te && this.$te(path)) return true;
      const i18n = this.$i18n || this.$root?.$i18n || this.$i18n?.global;
      if (!i18n) return false;
      const locale = i18n.locale || i18n.global?.locale;
      const messages = i18n.global?.messages?.[locale] || i18n.messages?.[locale];
      if (!messages) return false;
      const segments = path.split('.');
      let node = messages;
      for (const s of segments) {
        if (node && Object.prototype.hasOwnProperty.call(node, s)) {
          node = node[s];
        } else {
          return false;
        }
      }
      return typeof node === 'string';
    },
    normalizeIcon(icon) {
      if (!icon) return 'fa-solid fa-bell';
      if (icon.includes('fa-')) return icon;
      return `fa-solid fa-${icon}`;
    }
  },
  async mounted() {
    await this.fetchPage(1);
    await this.openFromQuery();
    window.addEventListener('notification:created', this.handleNotificationCreated);
    window.addEventListener('notification:updated', this.handleRealtimeUpdate);
    this.subscribeToChannel();
  },
  watch: {
    '$route.query.openId'(val) {
      if (val) this.ensureOpen(val);
    },
    notifications() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('notification:created', this.handleNotificationCreated);
    window.removeEventListener('notification:updated', this.handleRealtimeUpdate);
  }
};
</script>

<style scoped>
.box_component {
  width: 80%;
  max-width: 80%;
  margin: 15px auto;
}

@media (max-width: 576px) {
  .box_component {
    width: 100%;
    max-width: 100%;
  }
}

.notif-box {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  padding: 20px;
  margin-top: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.notif-title {
  font-size: 1.5rem;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-bottom: 6px;
}

.notif-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.notif-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
}

.notif-item.unread {
  background: rgba(13, 110, 253, 0.06);
  border-left: 3px solid #0d6efd;
  padding-left: 12px;
}

.notif-item {
  cursor: pointer;
}

.notif-list li:last-child {
  border-bottom: none;
}

.notif-list i {
  color: #6c757d;
  margin-top: 2px;
}

.notif-text strong {
  display: block;
  font-size: 1rem;
}

.notif-text small {
  display: block;
  margin-top: 2px;
}

.notif-controls {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 10px 12px;
}

.btn-ghost {
  border: none;
  background: transparent;
  padding: 4px 6px;
}

.btn-ghost:disabled {
  opacity: 0.4;
}

.notif-detail {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 10px 12px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* Estilos para el modal de confirmación */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-dialog {
  max-width: 500px;
  width: 90%;
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.modal-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
}

.modal-body {
  padding: 1rem;
}

.modal-footer {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
